module.exports = __webpack_public_path__ + "static/scale-model-of-texas-discovery-gardens-in-dallas-texas-de371c9161580975d9aafa907253c41e.png";